import { Environment } from 'rlv-common';
import { NODE_ENV } from './config';

export const isDevelopment = NODE_ENV === Environment.development;
export const isProduction = NODE_ENV === Environment.production;

export const ROOT_PDE = 'ecsp-personendatenerfassung';
export const ROOT_DUW = 'ecsp-duw';
